import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { Modal, Button, Collapse, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import SaveIcon from '@material-ui/icons/Save';
import { mask } from 'remask';
import MenuItem from '@material-ui/core/MenuItem';
import axios from 'axios';
import moment from 'moment';
import { UFS, CAMPO_OBRIGATORIO } from '../../consts/common';
import {
  isEmpty,
  isCepValid,
  isCnpjValid,
  getTipoTributacao,
  onlyNumbers,
  replaceSpecialChars,
} from '../../utils/common';
import { instanceAxios } from '../../InstanceAxios';
import 'moment/locale/pt-br';

function Empresa({
  empresa,
  cliente,
  handleUpdateEmpresa,
  cpf,
  handleAlert,
  cupom,
}) {
  const CNPJPattern = ['99.999.999/9999-99'];
  const CEPPattern = ['99.999-999'];
  const [tipoTributacao, setTipoTributacao] = useState([]);
  const [tipoEmpresa, setTipoEmpresa] = useState([]);
  const [errorCnpj, setErrorCnpj] = useState(!isCnpjValid(empresa.cnpj));
  const [errorRazaoSocial, setErrorRazaoSocial] = useState(
    isEmpty(empresa.razao_social)
  );
  const [errorTipoTributacao, setErrorTipoTributacao] = useState(
    isEmpty(empresa.tipo_tributacao)
  );
  const [errorTipoEmpresa, setErrorTipoEmpresa] = useState(
    isEmpty(empresa.tipo_empresa)
  );
  const [errorCnae, setErrorCnae] = useState(isEmpty(empresa.cnae));
  const [errorCep, setErrorCep] = useState(!isCepValid(empresa.cep));
  const [errorLogradouro, setErrorLogradouro] = useState(
    isEmpty(empresa.logradouro)
  );
  const [errorNumero, setErrorNumero] = useState(isEmpty(empresa.numero));
  const [errorComplemento, setErrorComplemento] = useState(
    isEmpty(empresa.complemento)
  );
  const [errorBairro, setErrorBairro] = useState(isEmpty(empresa.bairro));
  const [errorCidade, setErrorCidade] = useState(isEmpty(empresa.cidade));
  const [errorEstado, setErrorEstado] = useState(isEmpty(empresa.estado));
  const [errorCodigoSimples, setErrorCodigoSimples] = useState(
    isEmpty(empresa.codigo_simples)
  );

  const [hadChangeTrib, setHadChangeTrib] = useState(false);

  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [message, setMessage] = useState('');

  const [planosAssinaturas, setPlanosAssinaturas] = useState([]);
  const [planoSelecionado, setPlanoSelecionado] = useState({
    id_plano_iugu: '',
  });
  const [subscription, setSubscription] = useState('');
  const [modal, setModal] = useState(false);

  const isValid = ({
    ec = errorCnpj,
    er = errorRazaoSocial,
    ett = errorTipoTributacao,
    ete = errorTipoEmpresa,
    ecn = errorCnae,
    ecep = errorCep,
    el = errorLogradouro,
    en = errorNumero,
    eco = errorComplemento,
    eb = errorBairro,
    eci = errorCidade,
    ee = errorEstado,
    ecs = errorCodigoSimples,
  }) =>
    !ec &&
    !er &&
    !ett &&
    !ete &&
    !ecep &&
    !el &&
    !en &&
    !eco &&
    !eb &&
    !eci &&
    !ee &&
    !ecs;

  const isError = (ef) => empresa.cnpj !== '' && ef;

  const fetchSubscriptionPlans = async () => {
    const response = await instanceAxios(localStorage.getItem('toobiauth')).get(
      '/listarPlanos'
    );
    setPlanosAssinaturas(response.data);
  };

  const fetchSubscriptionUser = async () => {
    const response = await instanceAxios(localStorage.getItem('toobiauth')).get(
      `/buscarAssinaturaUsuario/${cliente.id}`
    );

    setSubscription(response.data.PlanoAssinatura);
  };

  useEffect(() => {
    const fetchUsernames = async () => {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/tiposEmpresaTributacao`)
        .then((res) => {
          setTipoTributacao(res.data.tipoTributacao);
          setTipoEmpresa(res.data.tipoEmpresa);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    fetchUsernames();
    fetchSubscriptionPlans();
  }, []);

  const handleAtualizarAssinatura = async () => {
    try {
      const response = await instanceAxios(
        localStorage.getItem('toobiauth')
      ).post('/alterarPlanoAssinaturaUsuario', {
        idUsuario: cliente.id,
        idPlano: planoSelecionado.identificador_iugu,
      });

      if (response.status === 200) {
        setAlertType('success');
        setMessage('Assinatura alterada com sucesso!');
        setAlert(true);
      }
    } catch (error) {
      setAlertType('error');
      setMessage('Erro ao atualizar assinatura!');
      setAlert(true);
    }

    setModal(false);
  };

  const handleChangeCepEmpresa = async (event) => {
    const obj = empresa;
    obj.cep = event.target.value.replace(/\D/g, '');
    if (isCepValid(event.target.value)) {
      await axios
        .get(
          `https://viacep.com.br/ws/${event.target.value.replace(
            /\D/g,
            ''
          )}/json`
        )
        .then((res) => {
          obj.cep = res.data.cep.replace(/\D/g, '');
          obj.bairro = res.data.bairro;
          obj.complemento = res.data.complemento;
          obj.cidade = res.data.localidade;
          obj.logradouro = res.data.logradouro;
          obj.estado = res.data.uf;
          obj.ibge = res.data.ibge;
          obj.numero = '';
          setErrorCep(!isCepValid(obj.cep));
          setErrorLogradouro(isEmpty(obj.logradouro));
          setErrorNumero(isEmpty(obj.numero));
          setErrorComplemento(isEmpty(obj.complemento));
          setErrorBairro(isEmpty(obj.bairro));
          setErrorCidade(isEmpty(obj.cidade));
          setErrorEstado(isEmpty(obj.estado));
          handleUpdateEmpresa(obj, isValid({}));
        })
        .catch((err) => {
          console.log(err);
          setErrorCep(false);
          handleUpdateEmpresa(
            obj,
            isValid({
              ecep: true,
            })
          );
          setErrorCep(false);
          handleAlert(true, 'warning', 'CEP não encontrado!');
        });
    } else {
      obj.cep = event.target.value.replace(/\D/g, '');
      setErrorCep(true);
      handleUpdateEmpresa(obj, false);
    }
  };

  const handleChangeCnpjEmpresa = async (event) => {
    const obj = empresa;
    obj.cnpj = event.target.value.replace(/\D/g, '');
    handleUpdateEmpresa(obj, false);
    if (event.target.value.replace(/\D/g, '').length === 14) {
      await axios
        .get(
          `http://www.receitaws.com.br/v1/cnpj/${event.target.value.replace(
            /\D/g,
            ''
          )}`
        )
        .then((res) => {
          obj.razao_social = res.data.nome;
          obj.cnpj = res.data.cnpj.replace(/\D/g, '');
          obj.tipo_tributacao = getTipoTributacao(res.data.nome, cpf);
          obj.tipo_empresa = obj.tipo_tributacao === 1 ? 1 : null;
          obj.cep = res.data.cep.replace(/\D/g, '');
          obj.logradouro = res.data.logradouro;
          obj.numero = res.data.numero;
          obj.complemento = res.data.complemento;
          obj.bairro = res.data.bairro;
          obj.cidade = res.data.municipio;
          obj.estado = res.data.uf;
          obj.cnae = res.data.atividade_principal
            ? onlyNumbers(res.data.atividade_principal[0].code)
            : '';

          setErrorCnpj(false);
          setErrorRazaoSocial(isEmpty(obj.razao_social));
          setErrorTipoTributacao(isEmpty(obj.tipo_tributacao));
          setErrorTipoEmpresa(isEmpty(obj.tipo_empresa));
          setErrorCep(!isCepValid(obj.cep));
          setErrorLogradouro(isEmpty(obj.logradouro));
          setErrorNumero(isEmpty(obj.numero));
          setErrorComplemento(isEmpty(obj.complemento));
          setErrorBairro(isEmpty(obj.bairro));
          setErrorCidade(isEmpty(obj.cidade));
          setErrorEstado(isEmpty(obj.estado));
          handleUpdateEmpresa(obj, true);
        })
        .catch((err) => {
          obj.bairro = '';
          obj.complemento = '';
          obj.cidade = '';
          obj.logradouro = '';
          obj.numero = '';
          obj.complemento = '';
          obj.bairro = '';
          obj.estado = '';
          obj.numero = '';
          setErrorCnpj(false);
          handleUpdateEmpresa(obj, true);
        });
    } else {
      handleUpdateEmpresa(obj, false);
      setErrorCnpj(true);
    }
  };

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            id="cnpj"
            label="CNPJ"
            variant="outlined"
            value={mask(empresa.cnpj, CNPJPattern)}
            onChange={handleChangeCnpjEmpresa}
            error={isError(errorCnpj)}
            helperText={CAMPO_OBRIGATORIO}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="CNPJ"
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            id="razaoSocial"
            label="Razão Social"
            variant="outlined"
            value={empresa.razao_social}
            onChange={(event) => {
              const obj = empresa;
              obj.razao_social = event.target.value;
              setErrorRazaoSocial(isEmpty(event.target.value));
              handleUpdateEmpresa(
                obj,
                isValid({
                  er: isEmpty(event.target.value),
                })
              );
            }}
            error={isError(errorRazaoSocial)}
            helperText={CAMPO_OBRIGATORIO}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Razão Social"
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            id="tipoTributacao"
            variant="outlined"
            select
            label="Tipo de Tributação"
            value={empresa.tipo_tributacao}
            onChange={(event) => {
              const obj = empresa;
              obj.tipo_tributacao = Number(event.target.value);
              setErrorTipoTributacao(isEmpty(event.target.value));
              fetchSubscriptionUser();
              setModal(true);
              handleUpdateEmpresa(
                obj,
                isValid({
                  ett: isEmpty(event.target.value),
                })
              );
              setHadChangeTrib(true);
            }}
            error={isError(errorTipoTributacao)}
            helperText={CAMPO_OBRIGATORIO}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Tipo Tributação"
          >
            {tipoTributacao.map((t) => (
              <MenuItem key={t.id} value={t.id}>
                {t.nome}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            id="tipoEmpresa"
            variant="outlined"
            select
            label="Tipo da Empresa"
            value={empresa.tipo_empresa}
            onChange={(event) => {
              const obj = empresa;
              obj.tipo_empresa = Number(event.target.value);
              setErrorTipoEmpresa(isEmpty(event.target.value));
              handleUpdateEmpresa(
                obj,
                isValid({
                  ete: isEmpty(event.target.value),
                })
              );
            }}
            error={isError(errorTipoEmpresa)}
            helperText={CAMPO_OBRIGATORIO}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Tipo Empresa"
          >
            {tipoEmpresa.map((t) => (
              <MenuItem key={t.id} value={t.id}>
                {t.nome}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={2}>
          <TextField
            fullWidth
            id="cnae"
            label="CNAE"
            variant="outlined"
            value={empresa.cnae}
            onChange={(event) => {
              const obj = empresa;
              obj.cnae = onlyNumbers(event.target.value);
              handleUpdateEmpresa(obj, isValid({ ecn: isEmpty(obj.cnae) }));
              setErrorCnae(isEmpty(obj.cnae));
            }}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="CNAE"
            error={isError(errorCnae)}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            id="codigo_simples"
            label="Código Simples"
            variant="outlined"
            value={empresa.codigo_simples}
            onChange={(event) => {
              const obj = empresa;
              obj.codigo_simples = onlyNumbers(event.target.value);
              setErrorCodigoSimples(isEmpty(event.target.value));

              handleUpdateEmpresa(
                obj,
                isValid({ ecs: isEmpty(obj.codigo_simples) })
              );
            }}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Código Simples"
            error={isError(errorCodigoSimples)}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            label="Vencimento Alvará"
            id="vencimento_alvara"
            variant="outlined"
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
            value={moment(empresa.vencimento_alvara).format('YYYY-MM-DD')}
            onChange={(data) => {
              const obj = empresa;
              obj.vencimento_alvara = moment(data.target.value).format(
                'YYYY-MM-DD'
              );
              handleUpdateEmpresa(obj, isValid({}));
            }}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            label="Vencimento Bombeiros"
            id="vencimento_bombeiros"
            variant="outlined"
            type="date"
            InputLabelProps={{
              shrink: true,
            }}
            value={moment(empresa.vencimento_bombeiros).format('YYYY-MM-DD')}
            onChange={(data) => {
              const obj = empresa;
              obj.vencimento_bombeiros = moment(data.target.value).format(
                'YYYY-MM-DD'
              );
              handleUpdateEmpresa(obj, isValid({}));
            }}
          />
        </Grid>
        <Grid item xs={3}>
          {cupom && cupom.HistoricoUsoCupoms.length ? (
            cupom.HistoricoUsoCupoms.map((item) => (
              <TextField
                key={item.id}
                id="cupom"
                label="CUPOM"
                variant="outlined"
                placeholder="CUPOM"
                disabled
                value={
                  item.CupomDeDesconto.cupom ? item.CupomDeDesconto.cupom : ''
                }
                helperText={`Válido até ${moment(item.created_at)
                  .add(item.CupomDeDesconto.qtdMeses, 'M')
                  .format('DD/MM/YYYY')}`}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            ))
          ) : (
            <TextField
              id="cupom"
              label="CUPOM"
              variant="outlined"
              placeholder="CUPOM"
              disabled
              value=""
              helperText=""
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="cep"
            label="CEP"
            variant="outlined"
            value={mask(empresa.cep, CEPPattern)}
            onChange={handleChangeCepEmpresa}
            error={isError(errorCep)}
            helperText={CAMPO_OBRIGATORIO}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="CEP"
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            id="logradouro"
            label="Logradouro"
            variant="outlined"
            value={empresa.logradouro}
            onChange={(event) => {
              const obj = empresa;
              obj.logradouro = replaceSpecialChars(event.target.value);
              handleUpdateEmpresa(
                obj,
                isValid({
                  el: isEmpty(obj.logradouro),
                })
              );
              setErrorLogradouro(isEmpty(obj.logradouro));
            }}
            InputLabelProps={{
              shrink: true,
            }}
            error={isError(errorLogradouro)}
            placeholder="Logradouro"
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            id="complemento"
            label="Complemento"
            variant="outlined"
            value={empresa.complemento}
            onChange={(event) => {
              const obj = empresa;
              obj.complemento = replaceSpecialChars(event.target.value);
              handleUpdateEmpresa(
                obj,
                isValid({
                  eco: isEmpty(obj.complemento),
                })
              );
              setErrorComplemento(isEmpty(obj.complemento));
            }}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Complemento"
            error={isError(errorComplemento)}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            id="numero"
            label="numero"
            variant="outlined"
            value={empresa.numero}
            onChange={(event) => {
              const obj = empresa;
              obj.numero = replaceSpecialChars(event.target.value);
              handleUpdateEmpresa(
                obj,
                isValid({
                  en: isEmpty(obj.numero),
                })
              );
              setErrorNumero(isEmpty(obj.numero));
            }}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Número"
            error={isError(errorNumero)}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            id="bairro"
            label="Bairro"
            variant="outlined"
            value={empresa.bairro}
            onChange={(event) => {
              const obj = empresa;
              obj.bairro = replaceSpecialChars(event.target.value);
              handleUpdateEmpresa(
                obj,
                isValid({
                  eb: isEmpty(obj.bairro),
                })
              );
              setErrorBairro(isEmpty(obj.bairro));
            }}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Bairro"
            error={isError(errorBairro)}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            id="cidade"
            label="Cidade"
            variant="outlined"
            value={empresa.cidade}
            onChange={(event) => {
              const obj = empresa;
              obj.cidade = replaceSpecialChars(event.target.value);
              handleUpdateEmpresa(
                obj,
                isValid({
                  eci: isEmpty(event.target.value),
                })
              );
              setErrorCidade(isEmpty(event.target.value));
            }}
            error={isError(errorCidade)}
            helperText={CAMPO_OBRIGATORIO}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Cidade"
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            select
            id="estado"
            label="Estado"
            variant="outlined"
            value={String(empresa.estado)}
            onChange={(event) => {
              const obj = empresa;
              obj.estado = event.target.value;
              handleUpdateEmpresa(
                obj,
                isValid({
                  ee: isEmpty(event.target.value),
                })
              );
              setErrorEstado(isEmpty(event.target.value));
            }}
            error={isError(errorEstado)}
            helperText={CAMPO_OBRIGATORIO}
            InputLabelProps={{
              shrink: true,
            }}
            placeholder="Estado"
          >
            {UFS.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>

      <Modal
        // className={classes.modal}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        open={modal}
        onClose={() => setModal(!modal)}
      >
        <div
          style={{
            position: 'absolute',
            backgroundColor: '#fff',
            border: '2px solid #000',
            top: `50%`,
            left: `50%`,
            transform: `translate(-50%, -50%)`,
            width: '50%',
            height: '50%',
            overflow: 'auto',
            padding: '20px',
          }}
        >
          <Grid container>
            <Grid item lg={12} md={12} sm={12} xl={12} xs={12}>
              <Collapse in={alert}>
                <Alert severity={alertType} onClick={() => setAlert(false)}>
                  {message}
                </Alert>
              </Collapse>
              <div align="center">
                <h1>Alterar Plano de Assinatura</h1>
              </div>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xl={6} xs={12}>
              <TextField
                required
                autoFocus
                helperText="Informe um tipo de assinatura"
                fullWidth
                id="tipoPlano"
                variant="outlined"
                select
                label="Plano"
                value={planoSelecionado.id_plano_iugu}
                onChange={(event) => {
                  const ps = planosAssinaturas.filter((pl) => {
                    if (pl.id_plano_iugu === event.target.value) {
                      return pl;
                    }
                  });

                  setPlanoSelecionado(ps[0]);
                }}
              >
                {planosAssinaturas.map((pa) => (
                  <MenuItem key={pa.id_plano_iugu} value={pa.id_plano_iugu}>
                    {pa.nome}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xl={6} xs={12}>
              <div align="right">
                <TextField
                  readOnly
                  size="medium"
                  id="valorPlano"
                  label="Valor Plano"
                  variant="outlined"
                  value={
                    planoSelecionado.valor
                      ? `R$${planoSelecionado.valor / 100}`
                      : 'R$'
                  }
                />
              </div>
            </Grid>

            <Grid item xs={12} style={{ marginTop: '20px' }}>
              <div>
                <Typography variant="h6">Assinatura Atual</Typography>
                <TextField
                  fullWidth
                  disabled
                  id="assinatura"
                  label="Assinatura Atual"
                  variant="outlined"
                  value={subscription.nome}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </Grid>

            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xl={12}
              xs={12}
              style={{ paddingTop: '10%' }}
            >
              <div align="right">
                <Button
                  size="medium"
                  variant="contained"
                  color="primary"
                  onClick={() => handleAtualizarAssinatura()}
                  startIcon={<SaveIcon />}
                >
                  Salvar
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </Modal>
    </>
  );
}

export default Empresa;
